export const repackCardFormDataForStripe = (data: any) => {
  const billingDetails = Object.fromEntries(
    Object.keys(data)
      .filter(key => key.startsWith('billing'))
      .map(key => [key, data[key]]),
  );
  // TODO: cardholder seems incorrect, related to
  // https://github.com/cloudbeds/payment-sdk-workspaces/blob/da4e12ccb00708f7063a96416ade0412c52eb929/packages/payment-tokenization/src/hooks/useStripe.ts#L142
  // TODO: this seems incorrect, should be cardholderName
  const { cardNumber, cardholderName, expiry, cvc, firstName, lastName } = data;
  return {
    firstName,
    lastName,
    ...(typeof cardNumber === 'string' && {
      cardNumber: cardNumber.replace(/ /g, ''),
    }),
    cardholderName, // TODO: this seems incorrect, should be cardholderName
    ...(typeof expiry === 'string' && {
      expMonth: +expiry?.split('/')[0]?.trim() || 0, // eslint-disable-line no-unsafe-optional-chaining
    }),
    ...(typeof expiry === 'string' && {
      expYear: 2000 + +expiry?.split('/')[1]?.trim() || 0, // eslint-disable-line no-unsafe-optional-chaining
    }),
    ...(typeof cvc === 'string' && { cvc }),
    billingDetails,
  };
};
